// extracted by mini-css-extract-plugin
module.exports = {"subjectLink":"subjectLink--3xKBx","table":"table--jMnNI"};